import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Table } from 'antd'
import { OrderListItem } from '../../../services/api/orders'
import { defaultPagination } from '../../../services/api/client/types'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { employeePath, orderPath } from '../../../routes/paths'
import { displayTime } from '../../../utils/formatter'
import { safePrintValue as sp } from '../../../utils'

type Props = {
  data?: OrderListItem[]
  meta?: {
    page: number | null
    perPage: number | null
    totalCount?: number
  }
  isLoading: boolean
  onPaginationChange: (page: number, perPage?: number) => void
}

export const OrdersTable: React.FunctionComponent<Props> = ({
  data,
  meta,
  isLoading,
  onPaginationChange,
}) => {
  const history = useHistory()

  return (
    <Table
      dataSource={data}
      columns={[
        {
          title: 'Номер заказа',
          dataIndex: 'number',
        },
        {
          title: 'Цена',
          dataIndex: 'priceAmount',
        },
        {
          title: 'Статус',
          dataIndex: 'status',
        },
        {
          title: 'Вылет',
          render: (_, order) =>
            displayTime(order.flight.parts[0].segments[0].departureTime),
        },
        {
          title: 'Полет завершен',
          render: (_, order) =>
            order.flight.completed ? <CheckOutlined /> : <CloseOutlined />,
        },
        {
          title: 'PNR / PCC / Provider',
          render: (_, order) =>
            `${sp(order.pnr)} / ${sp(order.pcc)} / ${sp(order.provider)}`,
        },
        {
          title: 'Пассажиры',
          render: (_, order) => {
            return (
              <>
                {order.passengers.map((passenger) => (
                  <>
                    <Link to={employeePath(passenger.id)}>
                      {passenger.firstNameRu} {passenger.lastNameRu}
                    </Link>
                    <br />
                  </>
                ))}
              </>
            )
          },
        },
      ]}
      loading={isLoading}
      rowKey={(order) => order.id}
      pagination={{
        onChange: onPaginationChange,
        current: meta?.page || defaultPagination.page,
        pageSize: meta?.perPage || defaultPagination.perPage,
        total: meta?.totalCount,
        defaultCurrent: defaultPagination.page,
        defaultPageSize: defaultPagination.perPage,
        hideOnSinglePage: true,
      }}
      onRow={(order) => {
        return {
          onClick: () => history.push(orderPath(order.id)),
        }
      }}
    />
  )
}
